var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',[_c('a',{staticClass:"ir-arriba",attrs:{"href":"#","title":"Volver arriba"}},[_c('span',{staticClass:"fa-stack"},[_c('i',{staticClass:"fa fa-circle fa-stack-2x"}),_c('i',{staticClass:"fa fa-arrow-up fa-stack-2x fa-inverse"})])])])
}]

export { render, staticRenderFns }